import { AddButton, CommonDateRange, CrossButton, CustomSelect } from 'components';
import React, { useContext, useEffect, useState } from 'react';
import { UserContext } from 'context';
import { getAllVehicleNumber, getStatesData } from '_services';
import moment from 'moment';
import StorageService from 'utils/StorageServices/StorageServices';
import { getBranchDropdownListData, getConsignorDropdownListData, getDriverDropdownListData, getSupplierDropdownListData } from '_services/dropdownServices/dropdownService';
import toast from 'react-hot-toast';

const InvoiceFilterModal = (props) => {

  let {
    isPartyDropdown = true,
    isBranchDropdown = true,
    isVehicleOwnershipDropdown = true,
    isVehicleNumberDropdown = true,
    isSupplierDropdown = true,
    isFromStationDropdown = true,
    isToStationDropdown = true,
    isPodStatusDropdown = true,
    isEwayBillStatusDropdown = true,
    isDriverDropdown = true,
    isStatusDropdown = true,
    isLrStatusDropdown = true,
    isOpen, onClose,
    filterCount, setFilterCount = () => { },
  } = props;
  const { masterData, states, cities, invoiceFilters, setInvoiceFilters } = useContext(UserContext)
  const [dropdownBranchList, setDropdownBranchList] = useState([]);
  const [consignorList, setConsignorList] = useState([]);
  const [vehicleNumbList, setVehicleNumbList] = useState([]);
  const [supplierList, setSupplierList] = useState([]);
  const [driverList, setDriverList] = useState([]);

  const [masterDataStatus, setMasterDataStatus] = useState([]);
  const [masterDataLrStatus, setMasterDataLrStatus] = useState([]);
  const [masterDataPodStatus, setMasterDataPodStatus] = useState([]);
  const [masterDataEwayBill, setMasterDataEwayBill] = useState([]);
  const [masterDataOwnerShip, setMasterDataOwnerShip] = useState([]);
  const [statesData, setStatesData] = useState([]);

  const [filters, setFilters] = useState({
    from_location: {},
    to_location: {},
    pod_status: {},
    vehicle_id: {},
    vehicle_ownership: {},
    lr_date_range: {
      startDate: "",
      endDate: ""
    },
    dispatch_date_range: {
      startDate: "",
      endDate: ""
    },
    indent_date_range: {
      startDate: "",
      endDate: ""
    },
    pod_date_range: {
      startDate: "",
      endDate: ""
    },
    consignor_id: {},
    template_id: {},
    company_id: "",
    limit: 25,
    offset: 1,
    search: "",
  })
  const [filterlabel, setfilterlabel] = useState({
    lr_date_range: {
      startDate: "",
      endDate: ""
    },
    dispatch_date_range: {
      startDate: "",
      endDate: ""
    },
    indent_date_range: {
      startDate: "",
      endDate: ""
    },
    pod_date_range: {
      startDate: "",
      endDate: ""
    },
  })

  useEffect(() => {
    if (masterData?.trip_status_list) {
      setMasterDataStatus(masterData?.trip_status_list?.map((i) => {
        return {
          label: i?.name,
          value: i?.id,
        };
      }))
    }
    if (masterData?.lr_status_list) {
      setMasterDataLrStatus(masterData?.lr_status_list?.map((i) => {
        return {
          label: i?.name,
          value: i?.id,
        };
      }))
    }
    if (masterData?.pod_status_list) {
      setMasterDataPodStatus(masterData?.pod_status_list?.map((el) => {
        return {
          label: el?.name,
          value: el?.id,
        };
      }))
    }
    if (masterData?.eway_bill_status_list) {
      setMasterDataEwayBill(masterData?.eway_bill_status_list?.map((el) => {
        return {
          label: el?.name,
          value: el?.id,
        };
      }))
    }

    if (masterData?.vehicle_ownership_list) {
      setMasterDataOwnerShip(masterData?.vehicle_ownership_list?.map((el) => ({
        label: el?.name,
        value: el?.id,
      })))
    }
  }, [masterData])

  const fetchVehicleList = async () => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        limit: 2000,
        offset: 1,
        search: "",
      };
      const vehicleRes = await getAllVehicleNumber(object);
      if (vehicleRes?.responseCode === 200) {
        const newVehicles = vehicleRes.data?.vehicle_list.map((i) => ({
          ...i,
          label: i.vehicle_no,
          value: i._id,
        }));
        let newData = {
          vehicle_no: 'All',
          label: 'All',
          value: '',
          lorry_type_id: {
            _id: '',
            lorry_type: ''
          },
          vehicle_ownership: 1,
          vehicle_status: 1,
          vehicle_type_id: {
            _id: '',
            name: 'All'
          },
          vehicle_type_id_1: {
            _id: '',
            name: 'All'
          }
        }
        setVehicleNumbList([newData, ...newVehicles]);
      } else {
        toast.error(vehicleRes?.responseMessage);
      }
    } catch (error) {
      toast.error("Error fetching vehicle list.");
    }
  };

  const getDropdownDataBranchList = async () => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        firm_id: StorageService.getFirmId(),
        search: "",
      };
      const res = await getBranchDropdownListData(object);
      if (res?.responseCode == 200) {
        let data = res?.data?.branch_list?.map((el) => {
          return {
            label: el?.branch,
            value: el?._id,
          }
        })
        setDropdownBranchList(data);
      }
    } catch (error) { }
  };

  const getDropdownDataConsignorList = async () => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        firm_id: StorageService.getFirmId(),
        limit: 100,
        offset: 1,
        search: '',
      }
      const res = await getConsignorDropdownListData(object);
      if (res?.responseCode == 200) {
        let data = res?.data?.consignor_list?.map((el) => {
          return {
            label: el?.name,
            value: el?._id,
          }
        })
        setConsignorList(data)
      }
    } catch (error) {
      // throw error;
    }
  }

  const getDropdownDataSupplierList = async () => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        firm_id: StorageService.getFirmId(),
        limit: 100,
        offset: 1,
      }
      const res = await getSupplierDropdownListData(object);
      if (res?.responseCode == 200) {
        let list = res?.data?.supplier_list.map((el) => {
          return {
            label: el?.name,
            value: el?._id,
          };
        });
        setSupplierList(list)
      } else {
        // setLoading(false);
      }
    } catch (error) {
      // setLoading(false);
      // throw error;
    }
  }

  const getDropdownDriverList = async () => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        firm_id: StorageService.getFirmId(),
        search: '',
        status: 1,
        driver_type: 0,
      }
      const res = await getDriverDropdownListData(object);
      if (res?.responseCode == 200) {
        let data = res?.data?.driver_list?.map((el) => {
          return {
            label: el?.name,
            value: el?._id,
          }
        })
        setDriverList(data)
      }
    } catch (error) {
      // throw error;
    }
  }

  const getStatesByApi = async () => {
    try {
      let data = {
        countryCode: "IN",
        stateCode: ""
      }
      let response = await getStatesData(data);
      if (response?.responseCode === 200) {
        const optionsState = response?.data?.map((d) => {
          return {
            ...d,
            label: d?.name,
            value: d?.name
          };
        });
        setStatesData(optionsState);
        StorageService.setStates(JSON.stringify([...optionsState]))
      } else {
        if (response) {
          toast.error(response?.responseMessage)
        }
      }
    } catch (error) {
      toast.error("An unexpected error occurred. Please try again.")
    }
  }

  useEffect(() => {
    if (isVehicleNumberDropdown) {
      fetchVehicleList();
    }
    getStatesByApi();
    // if (isBranchDropdown) {
    //   getDropdownDataBranchList();
    // }
    // if (isSupplierDropdown) {
    //   getDropdownDataSupplierList();
    // }
    // if (isPartyDropdown) {
    //   getDropdownDataConsignorList();
    // }
    // if (isDriverDropdown) {
    //   getDropdownDriverList();
    // }
  }, [])

  // useEffect(() => {
  //   if (vehicleNumbList?.length > 0) {
  //     setFilters((s) => ({
  //       ...s,
  //       vehicle_id: vehicleNumbList[0],
  //     }))
  //   }
  // }, [vehicleNumbList])

  const currentDate = new Date();
  const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
  const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

  const [selectedRange1, setSelectedRange1] = useState({
    startDate: moment().startOf('month'),
    endDate: moment().endOf('month'),
  });

  const [selectedRange2, setSelectedRange2] = useState({
    startDate: moment().startOf('month'),
    endDate: moment().endOf('month'),
  });

  const [selectedRange3, setSelectedRange3] = useState({
    startDate: moment().startOf('month'),
    endDate: moment().endOf('month'),
  });

  const [selectedRange4, setSelectedRange4] = useState({
    startDate: moment().startOf('month'),
    endDate: moment().endOf('month'),
  });

  const handleApply1 = (newRange) => {
    setSelectedRange1(newRange);
    setFilters((s) => ({
      ...s,
      lr_date_range: {
        startDate: moment(newRange?.startDate),
        endDate: moment(newRange?.endDate),
        // startDate: moment(newRange?.startDate).format("YYYY-MM-DD"),
        // endDate: moment(newRange?.endDate).format("YYYY-MM-DD"),
      }
    }));
    setfilterlabel((s) => ({
      ...s,
      lr_date_range: {
        startDate: moment(newRange?.startDate),
        endDate: moment(newRange?.endDate),
        // startDate: moment(newRange?.startDate).format("YYYY-MM-DD"),
        // endDate: moment(newRange?.endDate).format("YYYY-MM-DD"),
      }
    }));
  };

  const handleApply2 = (newRange) => {
    setSelectedRange2(newRange);
    // setFilters((s) => ({
    //   ...s,
    //   dispatch_date_range: {
    //     startDate: moment(newRange?.startDate).format("YYYY-MM-DD"),
    //     endDate: moment(newRange?.endDate).format("YYYY-MM-DD"),
    //   }
    // }));
    setFilters((s) => ({
      ...s,
      dispatch_date_range: {
        startDate: moment(newRange?.startDate),
        endDate: moment(newRange?.endDate),
        // startDate: moment(newRange?.startDate).format("YYYY-MM-DD"),
        // endDate: moment(newRange?.endDate).format("YYYY-MM-DD"),
      }
    }));
    setfilterlabel((s) => ({
      ...s,
      dispatch_date_range: {
        startDate: moment(newRange?.startDate),
        endDate: moment(newRange?.endDate),
        // startDate: moment(newRange?.startDate).format("YYYY-MM-DD"),
        // endDate: moment(newRange?.endDate).format("YYYY-MM-DD"),
      }
    }));
  };

  const handleApply3 = (newRange) => {
    setSelectedRange3(newRange);
    // setFilters((s) => ({
    //   ...s,
    //   indent_date_range: {
    //     startDate: moment(newRange?.startDate).format("YYYY-MM-DD"),
    //     endDate: moment(newRange?.endDate).format("YYYY-MM-DD"),
    //   }
    // }));
    setFilters((s) => ({
      ...s,
      indent_date_range: {
        startDate: moment(newRange?.startDate),
        endDate: moment(newRange?.endDate),
        // startDate: moment(newRange?.startDate).format("YYYY-MM-DD"),
        // endDate: moment(newRange?.endDate).format("YYYY-MM-DD"),
      }
    }));
    setfilterlabel((s) => ({
      ...s,
      indent_date_range: {
        startDate: moment(newRange?.startDate),
        endDate: moment(newRange?.endDate),
        // startDate: moment(newRange?.startDate).format("YYYY-MM-DD"),
        // endDate: moment(newRange?.endDate).format("YYYY-MM-DD"),
      }
    }));
  };

  const handleApply4 = (newRange) => {
    setSelectedRange4(newRange);
    // setFilters((s) => ({
    //   ...s,
    //   pod_date_range: {
    //     startDate: moment(newRange?.startDate).format("YYYY-MM-DD"),
    //     endDate: moment(newRange?.endDate).format("YYYY-MM-DD"),
    //   }
    // }));
    setFilters((s) => ({
      ...s,
      pod_date_range: {
        startDate: moment(newRange?.startDate),
        endDate: moment(newRange?.endDate),
        // startDate: moment(newRange?.startDate).format("YYYY-MM-DD"),
        // endDate: moment(newRange?.endDate).format("YYYY-MM-DD"),
      }
    }));
    setfilterlabel((s) => ({
      ...s,
      pod_date_range: {
        startDate: moment(newRange?.startDate),
        endDate: moment(newRange?.endDate),
        // startDate: moment(newRange?.startDate).format("YYYY-MM-DD"),
        // endDate: moment(newRange?.endDate).format("YYYY-MM-DD"),
      }
    }));
  };

  const onhandleSelect = async (item, name) => {
    const stateObj = { ...filters, [name]: item };
    setFilters(stateObj);
  };

  const resetFunction = () => {
    const newStartDate = moment().startOf('month');
    const newEndDate = moment().endOf('month');

    // setSelectedRange({
    //   startDate: newStartDate,
    //   endDate: newEndDate,
    // });

    setFilters((s) => ({
      ...s,
      offset: 1,
    }));
  };

  // const getFilterLabelCount = (filterlabel) => {
  //   let count = 0;

  //   Object.values(filterlabel).forEach((value) => {
  //     if (typeof value === "object" && value !== null) {
  //       if ("value" in value) {
  //         if (typeof value.value === "string" && value.value.trim() !== "") {
  //           count += 1;
  //         } else if (typeof value.value === "number" && value.value !== 0) {
  //           count += 1;
  //         }
  //       }
  //     } else if (typeof value === "string" && value.trim() !== "") {
  //       count += 1;
  //     } else if (typeof value === "number" && value !== 0) {
  //       count += 1;
  //     }
  //   });
  //   return count;
  // };

  const getFilterLabelCount = (filterlabel) => {
    let count = 0;

    Object.values(filterlabel).forEach((value) => {
      if (typeof value === "object" && value !== null) {
        const hasLabelValue =
          "label" in value &&
          "value" in value &&
          value.label !== "" &&
          value.value !== "";

        const hasStartEndDate =
          "startDate" in value &&
          "endDate" in value &&
          value.startDate !== "" &&
          value.endDate !== "";

        if (hasLabelValue || hasStartEndDate) {
          count += 1;
        }
      }
    });

    return count;
  };

  const handleSave = () => {
    setInvoiceFilters({
      ...invoiceFilters,
      from_location: filters?.from_location,
      to_location: filters?.to_location,
      pod_status: filters?.pod_status,
      vehicle_id: filters?.vehicle_id,
      vehicle_ownership: filters?.vehicle_ownership,
      lr_date_range: filters?.lr_date_range,
      dispatch_date_range: filters?.dispatch_date_range,
      indent_date_range: filters?.indent_date_range,
      pod_date_range: filters?.pod_date_range,
    });
    onClose(false);
  }

  const handleReset = () => {
    setfilterlabel((s) => ({
      ...s,
      lr_date_range: {
        startDate: '',
        endDate: '',
      },
      dispatch_date_range: {
        startDate: '',
        endDate: '',
      },
      indent_date_range: {
        startDate: '',
        endDate: '',
      },
      pod_date_range: {
        startDate: '',
        endDate: '',
      },
    }));
    setInvoiceFilters({
      from_location: {},
      to_location: {},
      pod_status: {},
      vehicle_id: {},
      vehicle_ownership: {},
      lr_date_range: {
        startDate: '',
        endDate: '',
      },
      dispatch_date_range: {
        startDate: '',
        endDate: '',
      },
      indent_date_range: {
        startDate: '',
        endDate: '',
      },
      pod_date_range: {
        startDate: '',
        endDate: '',
      },
      consignor_id: {},
      template_id: {},
      company_id: "",
      limit: 25,
      offset: 1,
      search: "",
      sort_field: "lr_number",
      sort_order: "asc"
    })
    setFilters({
      from_location: { label: "All", value: "" },
      to_location: { label: "All", value: "" },
      pod_status: { label: "All", value: "" },
      vehicle_id: { label: "All", value: "" },
      vehicle_ownership: { label: "All", value: "" },
      lr_date_range: {
        startDate: '',
        endDate: '',
      },
      dispatch_date_range: {
        startDate: '',
        endDate: '',
      },
      indent_date_range: {
        startDate: '',
        endDate: '',
      },
      pod_date_range: {
        startDate: '',
        endDate: '',
      },
      consignor_id: {},
      template_id: {},
      company_id: "",
      limit: 25,
      offset: 1,
      search: "",
    })
  }

  useEffect(() => {
    setfilterlabel((s) => ({
      ...s,
      lr_date_range: invoiceFilters?.lr_date_range,
      dispatch_date_range: invoiceFilters?.dispatch_date_range,
      indent_date_range: invoiceFilters?.indent_date_range,
      pod_date_range: invoiceFilters?.pod_date_range,
    }));
    setFilters({
      from_location: invoiceFilters?.from_location,
      to_location: invoiceFilters?.to_location,
      pod_status: invoiceFilters?.pod_status,
      vehicle_id: invoiceFilters?.vehicle_id,
      vehicle_ownership: invoiceFilters?.vehicle_ownership,
      lr_date_range: invoiceFilters?.lr_date_range,
      dispatch_date_range: invoiceFilters?.dispatch_date_range,
      indent_date_range: invoiceFilters?.indent_date_range,
      pod_date_range: invoiceFilters?.pod_date_range,
      consignor_id: {},
      template_id: {},
      company_id: "",
      limit: 25,
      offset: 1,
      search: "",
    })
    // let countValue = getFilterLabelCount({
    //   from_location: invoiceFilters?.from_location?.value ? invoiceFilters?.from_location : '',
    //   to_location: invoiceFilters?.to_location?.value ? invoiceFilters?.to_location : '',
    //   pod_status: invoiceFilters?.pod_status?.value ? invoiceFilters?.pod_status : '',
    //   vehicle_id: invoiceFilters?.vehicle_id?.value ? invoiceFilters?.vehicle_id : '',
    //   vehicle_ownership: invoiceFilters?.vehicle_ownership?.value ? invoiceFilters?.vehicle_ownership : '',
    //   lr_date_range: invoiceFilters?.lr_date_range,
    //   dispatch_date_range: invoiceFilters?.dispatch_date_range,
    //   indent_date_range: invoiceFilters?.indent_date_range,
    //   pod_date_range: invoiceFilters?.pod_date_range,
    // });
    // setFilterCount(countValue);
  }, [invoiceFilters]);

  return (
    <>
      <div className="offcanvas-header">
        <div className="d-flex gap-2 align-items-center">
          <h5 className="offcanvas-title"> Filters </h5>
          <div className="_counts"> {filterCount} </div>
        </div>
        <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }} onClick={(e) => onClose(false)}>
          <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
            <path
              d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
              fill="black" />
          </svg>
        </CrossButton>
      </div>

      <div className="offcanvas-body">
        <div className="_tableFilter_inrFx">
          <div className="_leftFilts">

            <div className="_filtrFlx">
              <CustomSelect
                name="from_location"
                label="From State"
                placeholder="All"
                options={[{ label: "All", value: "" }, ...statesData]}
                value={filters?.from_location}
                onSelect={(data) => onhandleSelect(data, 'from_location')}
              />
            </div>

            <div className="_filtrFlx">
              <CustomSelect
                name="to_location"
                label="To State"
                placeholder="All"
                options={[{ label: "All", value: "" }, ...statesData]}
                value={filters?.to_location}
                onSelect={(data) => onhandleSelect(data, 'to_location')}
              />
            </div>

            <div className="_filtrFlx">
              <CommonDateRange
                name='LR Date Range'
                // key={`${selectedRange1.startDate}-${selectedRange1.endDate}`}
                initialStartDate={filterlabel?.lr_date_range?.startDate ? filterlabel?.lr_date_range?.startDate : ''}
                initialEndDate={filterlabel?.lr_date_range?.endDate ? filterlabel?.lr_date_range?.endDate : ''}
                onApply={handleApply1}
                datePrefield={
                  !filterlabel?.lr_date_range?.startDate &&
                    !filterlabel?.lr_date_range?.endDate
                    ? false
                    : true
                }
              />
            </div>

            <div className="_filtrFlx">
              <CommonDateRange
                name='Dispatch Date Range'
                // key={`${selectedRange2.startDate}-${selectedRange2.endDate}`}
                // initialStartDate={selectedRange2.startDate}
                // initialEndDate={selectedRange2.endDate}
                initialStartDate={filterlabel?.dispatch_date_range?.startDate ? filterlabel?.dispatch_date_range?.startDate : ''}
                initialEndDate={filterlabel?.dispatch_date_range?.endDate ? filterlabel?.dispatch_date_range?.endDate : ''}
                onApply={handleApply2}
                datePrefield={
                  !filterlabel?.dispatch_date_range?.startDate &&
                    !filterlabel?.dispatch_date_range?.endDate
                    ? false
                    : true
                }
              />
            </div>

            <div className="_filtrFlx">
              <CommonDateRange
                name='Indent Date Range'
                // key={`${selectedRange3.startDate}-${selectedRange3.endDate}`}
                // initialStartDate={selectedRange3.startDate}
                // initialEndDate={selectedRange3.endDate}
                // onApply={handleApply3}
                initialStartDate={filterlabel?.indent_date_range?.startDate ? filterlabel?.indent_date_range?.startDate : ''}
                initialEndDate={filterlabel?.indent_date_range?.endDate ? filterlabel?.indent_date_range?.endDate : ''}
                onApply={handleApply3}
                datePrefield={
                  !filterlabel?.indent_date_range?.startDate &&
                    !filterlabel?.indent_date_range?.endDate
                    ? false
                    : true
                }
              />
            </div>

            {isPodStatusDropdown && <div className="_filtrFlx">
              <CustomSelect
                options={[{ label: 'All', value: '' }, ...masterDataPodStatus]}
                label="POD Status"
                placeholder="All"
                name="pod_status"
                value={filters?.pod_status}
                onSelect={(data) => onhandleSelect(data, 'pod_status')}
              />
            </div>}

            <div className="_filtrFlx">
              <CommonDateRange
                name='POD Date Range'
                // key={`${selectedRange4.startDate}-${selectedRange4.endDate}`}
                // initialStartDate={selectedRange4.startDate}
                // initialEndDate={selectedRange4.endDate}
                // onApply={handleApply4}
                initialStartDate={filterlabel?.pod_date_range?.startDate ? filterlabel?.pod_date_range?.startDate : ''}
                initialEndDate={filterlabel?.pod_date_range?.endDate ? filterlabel?.pod_date_range?.endDate : ''}
                onApply={handleApply4}
                datePrefield={
                  !filterlabel?.pod_date_range?.startDate &&
                    !filterlabel?.pod_date_range?.endDate
                    ? false
                    : true
                }
              />
            </div>

            <CustomSelect
              label="Vehicle"
              placeholder="All"
              name='vehicle_id'
              options={vehicleNumbList}
              value={filters?.vehicle_id}
              onSelect={(data) => onhandleSelect(data, 'vehicle_id')}
            />

            {/* {isPartyDropdown && <div className="_filtrFlx">
              <CustomSelect
                label='Party'
                placeholder="All"
                options={[{ label: "All", value: "" }, ...consignorList]}
                value={filters?.consignor_id}
                onSelect={(data) => onhandleSelect(data, 'consignor_id')}
              />
            </div>}


            {isVehicleOwnershipDropdown && <div className="_filtrFlx">
              <CustomSelect
                options={[{ label: 'All', value: '' }, ...masterDataOwnerShip]}
                name="ownership_no"
                label="Ownership"
                placeholder="All"
                value={invoiceFilters?.ownership_no}
                onSelect={(data) => onhandleSelect(data, 'ownership_no')}
              />
            </div>}

            {isVehicleNumberDropdown && <div className='__trps_select _filtrFlx' style={{ marginBottom: '20px' }}>
              <CustomSelect
                label="Vehicle Number"
                placeholder="All"
                options={vehicleNumbList}
                value={invoiceFilters?.vehicle_id}
                component_class="vehicle_number_trip"
                onSelect={(data) => onhandleSelect(data, 'vehicle_id')}
              />
            </div>}

            {isSupplierDropdown && <div className="_filtrFlx">
              <CustomSelect
                options={[{ label: 'All', value: '' }, ...supplierList]}
                label="Supplier"
                placeholder="All"
                name="supplier_id"
                value={invoiceFilters?.supplier_id}
                onSelect={(data) => onhandleSelect(data, 'supplier_id')}
              />
            </div>}

            {isFromStationDropdown && <div className="_filtrFlx">
              <CustomSelect
                options={[{ label: 'All', value: '', cityStateLabel: 'All' }, ...cities]}
                optionShowCityState={true}
                label="From Station"
                placeholder="All"
                name="from_location"
                value={invoiceFilters?.from_location}
                onSelect={(data) => onhandleSelect(data, 'from_location')}
              />
            </div>}

            {isToStationDropdown && <div className="_filtrFlx">
              <CustomSelect
                options={[{ label: 'All', value: '', cityStateLabel: 'All' }, ...cities]}
                optionShowCityState={true}
                label="To Station"
                placeholder="All"
                name="to_location"
                value={invoiceFilters?.to_location}
                onSelect={(data) => onhandleSelect(data, 'to_location')}
              />
            </div>}

            {isEwayBillStatusDropdown && <div className="_filtrFlx">
              <CustomSelect
                options={[{ label: 'All', value: '' }, ...masterDataEwayBill]}
                label="Eway Bill Status"
                placeholder="All"
                name="eway_bill_status"
                value={invoiceFilters?.eway_bill_status}
                onSelect={(data) => onhandleSelect(data, 'eway_bill_status')}
              />
            </div>}

            {isDriverDropdown && <div className="_filtrFlx">
              <CustomSelect
                options={[{ label: 'All', value: '' }, ...driverList]}
                label="Driver"
                placeholder="All"
                name="driver_id"
                value={invoiceFilters?.driver_id}
                onSelect={(data) => onhandleSelect(data, 'driver_id')}
              />
            </div>}

            {isStatusDropdown && <div className="_filtrFlx">
              <CustomSelect
                options={[{ label: 'All', value: '' }, ...masterDataStatus]}
                label="Status"
                placeholder="All"
                name="status"
                value={invoiceFilters?.status}
                onSelect={(data) => onhandleSelect(data, 'status')}
              />
            </div>}

            {isLrStatusDropdown && <div className="_filtrFlx">
              <CustomSelect
                options={[{ label: 'All', value: '' }, ...masterDataLrStatus]}
                label="Status"
                placeholder="All"
                name="status"
                value={invoiceFilters?.status}
                onSelect={(data) => onhandleSelect(data, 'status')}
              />
            </div>} */}

          </div>
        </div>
      </div >
      <div className="offcanvas-footer">
        <AddButton
          name="Save"
          className="_addComm_btn"
          onClick={handleSave}
          buttonTitle="Save"
        />
        <button className="_cancel_btn" onClick={handleReset}>
          Reset
        </button>
      </div>
    </>
  )
}

export default React.memo(InvoiceFilterModal)